import { isNumber, isString } from '../utils';
export const addRpx = (value) => {
    if (!value) {
        return value;
    }
    return isString(value) ? value : `${value}rpx`;
};
export const getValue = (cssProp) => {
    if (!cssProp) {
        return 0;
    }
    if (isNumber(cssProp)) {
        return cssProp;
    }
    const index = cssProp.indexOf('rpx');
    if (index === -1) {
        return Number(cssProp);
    }
    return Number(cssProp.substring(0, index));
};
export const statusColor = (status) => {
    const colorMap = {
        normal: '#209BFA',
        error: '#EB2F2F',
        success: '#05D161',
    };
    return colorMap[status];
};
export const progressBackgroundColor = (color) => color || '#f2f2f2';
export const progressSize = (size) => {
    const sizeMap = {
        small: 4,
        medium: 6,
        large: 8,
    };
    return sizeMap[size] || size;
};
export const progressiveColor = (percent) => {
    if (percent < 33) {
        return '#EB2F2F';
    }
    if (percent > 66) {
        return '#05D161';
    }
    return '#D97B00';
};
export const progressCircleWidthSize = (size) => {
    const sizeMap = {
        small: 22,
        medium: 28,
        large: 34,
    };
    return sizeMap[size] || size;
};
export const progressCircleFontSize = (size) => {
    const sizeMap = {
        small: 14,
        medium: 16,
        large: 18,
    };
    return sizeMap[size] || size;
};
